export default "__VITE_ASSET__Cglf9RZq__"